import {FaApple} from "react-icons/fa6";

function DownloadCTA() {
    return (
        <>
            <section id="download" className="download-cta">
                <div className="sl" style={{display:"inline-block"}}>Download</div>
                <h2>Take control of your energy today.</h2>
                <p>Inaread is free to download. Available on iPhone and Android. No hardware or smart meter required.</p>
                <div className="dl-row">
                    <a href="https://forms.gle/1JaFncC2JPeL87LNA" className="dl-btn dl-btn-lg">
                        <FaApple size={30}/>
                        <span className="store-text">
        <span className="store-sub">Coming soon on</span>
        <span className="store-name">App Store</span>
      </span>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=dev.gbenga.inaread" className="dl-btn dl-btn-fill dl-btn-lg">
                        <span className="store-icon">▶</span>
                        <span className="store-text">
        <span className="store-sub">Get it on</span>
        <span className="store-name">Google Play</span>
      </span>
                    </a>
                </div>
                <div className="qr-hint">Scan the QR code in-store or search <strong style={{color: "rgba(232,234,246,.55)"}}>Inaread</strong> on the App Store or Google Play</div>
            </section>

        </>
    )
}

export default DownloadCTA;
